import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"
import BulkImportExport from "../../components/BulkImportExport"

const BulkVendors = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.BULK_VENDORS
  const [vendors, setVendors] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [vendorId, setVendorId] = useState("")
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [filterCompany, setFilterCompany] = useState("")
  const [filterPlant, setFilterPlant] = useState("")
  const [filterCC, setFilterCC] = useState("")
  const [filterRoute, setFilterRoute] = useState("")
  const [filterName, setFilterName] = useState("")
  const [filterStatus, setFilterStatus] = useState("")

  const fetchData = useCallback(async () => {
    try {
      const resp = await api.get("vendors")
      setVendors(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.delete("delete-vendor/" + vendorId); fetchData() } catch (e) { console.error(e) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-vendor", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(vendors.length > 0 && vendors.every(v => n[v.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; vendors.forEach(v => { items[v.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  // Check if multiple companies exist
  const multipleCompanies = useMemo(() => new Set(vendors.map(v => v.companyName).filter(Boolean)).size > 1, [vendors])

  // Unique filter options
  const uniqueCompanies = useMemo(() => [...new Set(vendors.map(v => v.companyName).filter(Boolean))].sort(), [vendors])
  const uniquePlants = useMemo(() => [...new Set(vendors.map(v => v.plantName).filter(Boolean))].sort(), [vendors])
  const uniqueCCs = useMemo(() => [...new Set(vendors.map(v => v.chillingCenterName).filter(Boolean))].sort(), [vendors])
  const uniqueRoutes = useMemo(() => [...new Set(vendors.map(v => v.routeName).filter(Boolean))].sort(), [vendors])

  const filtered = useMemo(() => {
    return vendors.filter(v => {
      if (filterCompany && v.companyName !== filterCompany) return false
      if (filterPlant && v.plantName !== filterPlant) return false
      if (filterCC && v.chillingCenterName !== filterCC) return false
      if (filterRoute && v.routeName !== filterRoute) return false
      if (filterName && !(v.vendorName || "").toLowerCase().includes(filterName.toLowerCase())) return false
      if (search) {
        const s = search.toLowerCase()
        return (v.vendorName || "").toLowerCase().includes(s) ||
          (v.vendorNumber || "").toLowerCase().includes(s) ||
          (v.chillingCenterName || "").toLowerCase().includes(s) ||
          (v.routeName || "").toLowerCase().includes(s) ||
          (v.plantName || "").toLowerCase().includes(s) ||
          (v.companyName || "").toLowerCase().includes(s) ||
          (v.canNumber || "").toLowerCase().includes(s) ||
          (v.venodrMobile || "").toLowerCase().includes(s)
      }
      return true
    })
  }, [vendors, search, filterCompany, filterPlant, filterCC, filterRoute, filterName])

  const removeFilter = () => {
    setFilterCompany(""); setFilterPlant(""); setFilterCC(""); setFilterRoute(""); setFilterName(""); setFilterStatus("")
    setShowFilter(!showFilter)
  }

  const summaryCards = [
    { label: "Total Vendors", value: vendors.length, icon: "fa-users", color: "#6366f1" },
    { label: "Chilling Centers", value: new Set(vendors.map(v => v.chillingCenterName).filter(Boolean)).size, icon: "fa-warehouse", color: "#0ea5e9" },
    { label: "Routes", value: new Set(vendors.map(v => v.routeName).filter(Boolean)).size, icon: "fa-route", color: "#22c55e" },
  ]

  const colSpan = multipleCompanies ? 12 : 11

  return (
    <>
      <div className="dashBody">

        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>Bulk Vendors</h4>
            {canAdd(MID) && (
              <Link to="/add-vendor" title="Add Vendor"
                style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#28a745", color: "#fff",
                  display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", textDecoration: "none" }}>
                <i className="fas fa-plus"></i>
              </Link>
            )}
            {canDelete(MID) && (
              <button title={selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete"}
                onClick={() => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Please select at least one vendor to delete.") }}
                style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#dc3545", color: "#fff",
                  border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", opacity: selectedCount > 0 ? 1 : 0.7 }}>
                <i className="fas fa-trash"></i>
              </button>
            )}
            <button title="Toggle Filter" onClick={removeFilter}
              style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#0d6efd", color: "#fff",
                border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
              <i className="fas fa-filter"></i>
            </button>
            <BulkImportExport
              data={vendors}
              columns={[
                { key: "chillingCenter", label: "Chilling Center ID", required: true },
                { key: "route", label: "Route ID", required: true },
                { key: "vendorName", label: "Vendor Name", required: true },
                { key: "vendorNumber", label: "Vendor Number", required: true },
                { key: "canNumber", label: "Can Number" },
                { key: "procurementType", label: "Procurement Type" },
                { key: "door", label: "Door No" },
                { key: "village", label: "Village" },
                { key: "venodrMobile", label: "Vendor Mobile" },
                { key: "rateChartType", label: "Rate Chart Type (0=Common, 1=Separate)", required: true },
                { key: "paymentMode", label: "Payment Mode (0=Cash, 1=Bank)", required: true },
                { key: "limitVendorCc", label: "Limit Single Entry (1=Yes, 0=No)", required: true },
                { key: "smsCcPurchases", label: "Send SMS (1=Yes, 0=No)", required: true },
              ]}
              sampleData={[{
                chillingCenter: "1", route: "1", vendorName: "Sample Vendor", vendorNumber: "V001",
                canNumber: "CAN001", procurementType: "3rd Party Collection", door: "1-2-3",
                village: "Sample Village", venodrMobile: "9876543210",
                rateChartType: "0", paymentMode: "0", limitVendorCc: "0", smsCcPurchases: "0"
              }]}
              apiEndpoint="create-vendor"
              entityName="Bulk_Vendors"
              onImportComplete={fetchData}
              showExport={canExport(MID)}
              showImport={canAdd(MID)}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        {/* Summary Cards */}
        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px"
              }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15",
                  display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="vendorsTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                {multipleCompanies && <th>Company</th>}
                <th>Plant</th>
                <th>Chilling Center</th>
                <th>Route</th>
                <th>Vendor Code</th>
                <th>Vendor Name</th>
                <th>Vendor Number</th>
                <th>Contact Number</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  {multipleCompanies && (
                    <td>
                      <select className="form-control form-control-sm" value={filterCompany}
                        onChange={e => setFilterCompany(e.target.value)}>
                        <option value="">All</option>
                        {uniqueCompanies.map((c, i) => <option key={i} value={c}>{c}</option>)}
                      </select>
                    </td>
                  )}
                  <td>
                    <select className="form-control form-control-sm" value={filterPlant}
                      onChange={e => setFilterPlant(e.target.value)}>
                      <option value="">All</option>
                      {uniquePlants.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    </select>
                  </td>
                  <td>
                    <select className="form-control form-control-sm" value={filterCC}
                      onChange={e => setFilterCC(e.target.value)}>
                      <option value="">All</option>
                      {uniqueCCs.map((c, i) => <option key={i} value={c}>{c}</option>)}
                    </select>
                  </td>
                  <td>
                    <select className="form-control form-control-sm" value={filterRoute}
                      onChange={e => setFilterRoute(e.target.value)}>
                      <option value="">All</option>
                      {uniqueRoutes.map((r, i) => <option key={i} value={r}>{r}</option>)}
                    </select>
                  </td>
                  <td></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Name..."
                    value={filterName} onChange={e => setFilterName(e.target.value)} /></td>
                  <td></td><td></td><td></td><td></td>
                </tr>
              )}
              {!dataLoaded ? (
                <tr><td colSpan={colSpan}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
              ) : filtered.length > 0 ? (
                filtered.map((vendor, i) => (
                  <tr key={vendor.id}>
                    <td><input type="checkbox" checked={!!checkedItems[vendor.id]} onChange={() => handleCheckbox(vendor.id)} /></td>
                    <td>{i + 1}</td>
                    {multipleCompanies && (
                      <td><span style={{ background: '#f59e0b15', color: '#f59e0b', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{vendor.companyName || 'Unassigned'}</span></td>
                    )}
                    <td><span style={{ background: '#6366f115', color: '#6366f1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{vendor.plantName || 'Unassigned'}</span></td>
                    <td><span style={{ background: '#0ea5e915', color: '#0ea5e9', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{vendor.chillingCenterName || 'Unassigned'}</span></td>
                    <td><span style={{ background: '#22c55e15', color: '#22c55e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{vendor.routeName || 'Unassigned'}</span></td>
                    <td><span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#64748b' }}>{vendor.canNumber || "-"}</span></td>
                    <td style={{ fontWeight: "600" }}>{vendor.vendorName}</td>
                    <td>{vendor.vendorNumber}</td>
                    <td>{vendor.venodrMobile || "-"}</td>
                    <td>
                      <span style={{
                        background: "#dcfce7", color: "#16a34a",
                        padding: '3px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 600
                      }}>Active</span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "4px" }}>
                        {canEdit(MID) && <Link title="Edit" to={"/edit-vendor/" + vendor.id}
                          style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                          <i className="fas fa-edit"></i></Link>}
                        {canDelete(MID) && (
                          <button title="Delete" onClick={() => { setVendorId(vendor.id); setconfirm_alert(true) }}
                            style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#dc3545", color: "#fff",
                              border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}>
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={colSpan} className="text-center py-4">
                  <i className="fas fa-users fa-2x text-muted mb-2 d-block"></i>No vendors found
                </td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Vendor deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} vendors?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Vendors deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default BulkVendors
